/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assigned_Persona_NameInputs */

const en_assigned_persona_name = /** @type {(inputs: Assigned_Persona_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigned Persona Name`)
};

const es_assigned_persona_name = /** @type {(inputs: Assigned_Persona_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de la persona asignada`)
};

const fr_assigned_persona_name = /** @type {(inputs: Assigned_Persona_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du persona assigné`)
};

const de_assigned_persona_name = /** @type {(inputs: Assigned_Persona_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugewiesener Persona-Name`)
};

const ja_assigned_persona_name = /** @type {(inputs: Assigned_Persona_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`割り当てられたペルソナ名`)
};

const zh_assigned_persona_name = /** @type {(inputs: Assigned_Persona_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指定的人物角色名称`)
};

const ar_assigned_persona_name = /** @type {(inputs: Assigned_Persona_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسم الشخصية المعينة`)
};

const id_assigned_persona_name = /** @type {(inputs: Assigned_Persona_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama Persona yang Ditugaskan`)
};

const it_assigned_persona_name = /** @type {(inputs: Assigned_Persona_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome Persona Assegnato`)
};

const ru_assigned_persona_name = /** @type {(inputs: Assigned_Persona_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назначенное имя персоны`)
};

const pt_assigned_persona_name = /** @type {(inputs: Assigned_Persona_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da Persona Atribuída`)
};

const ko_assigned_persona_name = /** @type {(inputs: Assigned_Persona_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`부여된 페르소나 이름`)
};

/**
* | output |
* | --- |
* | "Assigned Persona Name" |
*
* @param {Assigned_Persona_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const assigned_persona_name = /** @type {((inputs?: Assigned_Persona_NameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assigned_Persona_NameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_assigned_persona_name(inputs)
	if (locale === "es") return es_assigned_persona_name(inputs)
	if (locale === "fr") return fr_assigned_persona_name(inputs)
	if (locale === "de") return de_assigned_persona_name(inputs)
	if (locale === "ja") return ja_assigned_persona_name(inputs)
	if (locale === "zh") return zh_assigned_persona_name(inputs)
	if (locale === "ar") return ar_assigned_persona_name(inputs)
	if (locale === "id") return id_assigned_persona_name(inputs)
	if (locale === "it") return it_assigned_persona_name(inputs)
	if (locale === "ru") return ru_assigned_persona_name(inputs)
	if (locale === "pt") return pt_assigned_persona_name(inputs)
	return ko_assigned_persona_name(inputs)
});